import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import InSchedulelayout from './InSchedulelayout';
import axiosInstance from '../../../../Services/axiosCommon';
import voiceEvacuation from '../../../../../src/assets/images/voice-evacuation.png';
import ASD from '../../../../../src/assets/images/ASD.png';
import aerosol from '../../../../../src/assets/images/aerosol.png';
import FireAlarm from '../../../../../src/assets/images/fire-alarm.png';
import cleanagent from '../../../../../src/assets/images/clean-agent.png';
import fireextinguisher from '../../../../../src/assets/images/fire-extinguisher.png';
import firehosecabinet from '../../../../../src/assets/images/fire-hose-cabinet.png';
import firewatertank from '../../../../../src/assets/images/fire-water-tank.png';
import foamsystem from '../../../../../src/assets/images/foam-system.png';
import kitchenhoodfs from '../../../../../src/assets/images/kitchen-hood.png';
import standpipe from '../../../../../src/assets/images/standpipe.png';
import firepump from '../../../../../src/assets/images/firepump.png';
import firehydrant from '../../../../../src/assets/images/fire-hydrant.png';
import fireprotect from '../../../../../src/assets/images/fireprotect.png';
import defaulr from '../../../../../src/assets/images/defaulr.jpeg';
import { MapPin } from 'lucide-react';
import { SubmitButton } from '../../../../Components/Utils/Buttons';
import { useToast } from '../../../../Components/Others/ToastServices';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import SendOTP from './SendOTP';
import NewformCerti from './NewformCerti';
import NuDate from '../../../../Components/Utils/NuDate';





const formImages = {
  "Fire Protection System - Summary": fireprotect,
  "Fire Pump": firepump,
  "FIRE WATER TANKS": firewatertank,
  "FIRE / FOAM HOSE CABINET": firehosecabinet,
  "FIRE / FOAM HOSE CABINET DETAILS": firehosecabinet,
  "FIRE EXTINGUISHER": fireextinguisher,
  "FIRE EXTINGUISHER DETAILS": fireextinguisher,
  "CLEAN AGENT FIRE SUPPRESSION SYSTEM": cleanagent,
  "FIRE ALARM SYSTEM": FireAlarm,
  "ASPIRATING SMOKE DETECTION SYSTEM": ASD,
  "ASD SYSTEM": ASD,
  "VOICE EVACUATION SYSTEM /PAVA": voiceEvacuation,
  "STAND PIPE HOSE SYSTEM": standpipe,
  "FOAM FIRE SUPPRESSION SYSTEM": foamsystem,
  "FIRE HYDRANT": firehydrant,
  "KITCHEN HOOD FIRE SUPPRESSION SYS.": kitchenhoodfs,
  "Aerosol Fire Suppression System": aerosol
};

// Using a simple document icon as default
const defaultImage = defaulr;

function NewForm() {
  const { scheduleViewId } = useParams();
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmittted, setisSubmittted] = useState(false);
  const [allSubmitted, setAllSubmitted] = useState(false);
  const [open, setOpen] = useState(false);
  const toast = useToast();

  const fetchTasks = async (value) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/schedules/forms/${value}`);
      setForms(response.data?.data || []);
            setisSubmittted(response?.data?.isSubmitted === false);
      checkAllSubmitted();

    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);

  const [selectedForm, setSelectedForm] = useState(null);
  const [selectCerti, setSelectCerti] = useState(null);

  const viewForm = async (value) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/schedules/get-signatures/${scheduleViewId}`);
      // setSelectedForm(response.data?.data?.inspection|| []);
          const responseData = response.data?.data;
        setSelectedForm(responseData?.inspection);
        setSelectCerti(responseData);

    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(()=>{
    viewForm(scheduleViewId);
  }, [scheduleViewId]);
  const handleSendOTP = () => setOpen(true);

 const checkAllSubmitted = async () => {
    try {
      const response = await axiosInstance.get(
        `/schedules/check-submitted/${scheduleViewId}`
      );
      console.log("Check Submitted Status", response.data);
      // fetchTasks(scheduleViewId)

      setAllSubmitted(response.data?.data === true);
    } catch (error) {
      console.error("Error checking submission status:", error);
    }
  };

  useEffect(() => {
    if (scheduleViewId) {
      checkAllSubmitted();
      fetchTasks(scheduleViewId);
    }
  }, [scheduleViewId]);
    const [otpEnable, setOtpEnable] = useState(false);

  const [openEnable, setEnableOpen] = useState(false);
  

  // Fetch OTP enable status
  const checkOtpEnable = async () => {
    try {
      const response = await axiosInstance.get(`/schedules/is-otp-enabled`);
      console.log("Check Submitted Status", response.data);

      if (response.data?.status) {
        setOtpEnable(response.data.data === true);
      } else {
        console.warn("Unexpected response status:", response.data);
        setOtpEnable(false);
      }
    } catch (error) {
      console.error("Error checking submission status:", error);
      setOtpEnable(false);
    }
  };

  // On button click, open confirm popup
  const handleEnableOTP = () => setEnableOpen(true);

  // On confirm, call verify API
  const handleVerifyOTP = () => {
    setLoading(true);
    axiosInstance
      .put(`/schedules/verify-otp/${scheduleViewId}`, { opt: "" })
      .then((res) => {
        if (res.data.status) {
          toast.open({
            type: "success",
            message: "OTP Verified",
          });
          fetchTasks(scheduleViewId);
        } else {
          toast.open({
            type: "error",
            message: "Invalid OTP",
            description: res.data.msg,
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Network Error",
          description: err.message,
        });
      })
      .finally(() => {
        setLoading(false);
        setEnableOpen(false);
      });
  };

  // On page load, check status and fetch tasks
  useEffect(() => {
    checkOtpEnable();
    fetchTasks(scheduleViewId);
  }, [scheduleViewId]);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'new': return 'bg-red-700';
      case 'in progress': return 'bg-yellow-400';
      case 'completed': return 'bg-green-700';
      case 'submitted': return 'bg-blue-700';
      case 'draft': return 'bg-orange-500';
      default: return 'bg-gray-700';
    }
  };

const formatDateTime = (dateTime) => {
  if (!dateTime) return 'N/A';

  const date = new Date(dateTime);

  const formattedDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\//g, '-');

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return `${formattedDate}, ${formattedTime}`;
};
 const navigate = useNavigate();
const handleFormClick = (form) => {
  navigate(`/inspection/schedule/formOpen/${form.id}`, {
    state: { form }
  });
};
 const [showCertificate, setShowCertificate] = useState(false);

 const handleFormCerti = () => {
    console.log('Opening certificate for schedule:', scheduleViewId);
    setShowCertificate(true);
  };

  // If showing certificate, render it
  if (showCertificate) {
    return (
      <InSchedulelayout>
        <NewformCerti allSubmitted={allSubmitted}/>
        {/* <div className="p-4">
          <button 
            onClick={() => setShowCertificate(false)}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Back to Forms
          </button>
        </div> */}
      </InSchedulelayout>
    );
  }

const getStatusBadgeColor = (status) => {
  switch (status) {
    case 'new': return 'bg-red-700';
      case 'in progress': return 'bg-yellow-400';
      case 'completed': return 'bg-green-700';
      case 'submitted': return 'bg-blue-700';
     

      default: return 'bg-gray-700';
  }
};
const getStatusBorderColor = (status) => {
  switch (status) {
     case 'new': return 'border-red-700';
      case 'in progress': return 'border-yellow-400';
      case 'completed': return 'border-green-700';
      case 'submitted': return 'border-blue-700';
     

      default: return 'border-gray-700';
  }
};


  return (
   <InSchedulelayout>
  <div className="bg-white h-[calc(100vh-160px)] rounded-md flex flex-col">

    {/* Top buttons */}
    <div>
      {allSubmitted && isSubmittted && otpEnable && (
        <div className="w-full p-4 flex justify-end">
          <SubmitButton name="Verify with OTP" handleClick={handleSendOTP} />
        </div>
      )}
      {!otpEnable && isSubmittted && (
        <div className="w-full p-4 flex justify-end">
          <SubmitButton name="Verify" handleClick={handleEnableOTP} />
        </div>
      )}
    </div>

    {/* Scrollable content area */}
    <div className="flex-1 overflow-y-auto p-2">

      {/* If no forms */}
      {forms.length === 0 ? (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No forms available</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6">
       <div
                className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300 h-auto flex flex-col cursor-pointer"
             onClick={handleFormCerti}      >
              <div className="bg-red-700 px-3 py-3 border-b border-gray-200 flex items-center justify-between">
                <h2 className="text-sm font-semibold text-white truncate">Inspection certificate</h2>
                <div className="flex items-center gap-2">
                  <div className="bg-white rounded-full p-0.5 flex items-center justify-center">
                    <span className={`inline-block w-3 h-3 rounded-full ${getStatusColor(allSubmitted ? "Complete" : "Draft")}`}></span>
                  </div>
                </div>
              </div>

              <div className="flex justify-end mt-2 mx-2 gap-2">
                <div className="flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs">
  {/* Left section - label */}
  <div className={`p-2 h-6 text-gray-700 rounded-s-full flex items-center border ${
      allSubmitted ? "border-green-500" : "border-orange-500"
    }`}>
    Status
  </div>

  {/* Right section - dynamic color */}
  <div
    className={`p-2 h-6 text-white rounded-e-full flex items-center ${
      allSubmitted ? "bg-green-500" : "bg-orange-500"
    }`}
  >
    {allSubmitted ? "completed" : "draft"}
  </div>
</div>

              </div>

              <div className="p-4 sm:flex flex-1">
                <div className="w-auto h-auto sm:w-20 sm:h-20 flex-shrink-0 flex items-center justify-center mr-4">
                  <img
                    src={defaultImage}
                    alt={"formName"}
                    className="w-16 h-16 object-contain"
                    onError={(e) => {
                      e.target.src = defaultImage;
                    }}
                  />
                </div>

                <div className="flex-1">
                  <div className="space-y-2">
                     <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Certificate Ref.</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {selectCerti?.certRefNumber || 'None'}</p>
                    </div>
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Schedule</p>
                      <p className="text-sm sm:w-[50%] font-medium">: <NuDate value={selectedForm?.date || 'None'} /></p>
                    </div>
                   
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Inspection Ref</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {selectedForm?.refNumber || 'None'}</p>
                    </div>
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Inspection Status</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {selectedForm?.status || 'None'}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-2 bg-gray-50 border-t border-gray-200 flex gap-2 text-sm w-full line-clamp-1">
                <span className="mt-0.5">
                  <MapPin size={14} />
                </span>
                <p className='text-sm'>{selectedForm?.location || 'None'}</p>
              </div>
            </div>
          {forms.map((form, index) => (
            <div
              key={form.id}
              className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300 h-auto flex flex-col cursor-pointer"
              onClick={() => handleFormClick(form)}
            >
              <div className="bg-red-700 px-3 py-3 border-b border-gray-200 flex items-center justify-between">
                <h2 className="text-sm font-semibold text-white truncate">{form.formName}</h2>
                <div className="flex items-center gap-2">
                  <div className="bg-white rounded-full p-0.5 flex items-center justify-center">
                    <span className={`inline-block w-3 h-3 rounded-full ${getStatusColor(form.status)}`}></span>
                  </div>
                </div>
              </div>

              <div className="flex justify-end mt-2 mx-2 gap-2">
                <div className="flex items-center overflow-hidden rounded-full text-[10px] 2xl:text-xs">
                  <div className={`p-2 h-6 text-gray-700 rounded-s-full flex items-center border border-gray-300 ${getStatusBorderColor(form.status)}`}>
                    Status
                  </div>
                  <div className={`p-2 h-6 ${getStatusBadgeColor(form.status)} text-white rounded-e-full flex items-center`}>
                    {form?.status || "-"}
                  </div>
                </div>
              </div>

              <div className="p-4 sm:flex flex-1">
                <div className="w-auto h-auto sm:w-20 sm:h-20 flex-shrink-0 flex items-center justify-center mr-4">
                  <img
                    src={formImages[form.formName] || defaultImage}
                    alt={form.formName}
                    className="w-16 h-16 object-contain"
                    onError={(e) => {
                      e.target.src = defaultImage;
                    }}
                  />
                </div>

                <div className="flex-1">
                  <div className="space-y-2">
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Schedule</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {formatDateTime(form.dateTime)}</p>
                    </div>
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Assigned To</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {form.assignees && form.assignees.length > 0 ? form.assignees.map(a => a.assigneeName).join(", ") : 'Unassigned'}</p>
                    </div>
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Updated by</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {form.updatedByName || 'None'}</p>
                    </div>
                    <div className="flex w-full">
                      <p className="text-sm sm:w-[30%] text-gray-500">Last Updated</p>
                      <p className="text-sm sm:w-[50%] font-medium">: {form.updatedOn ? formatDateTime(form.updatedOn) : 'Never'}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-2 bg-gray-50 border-t border-gray-200 flex gap-2 text-sm w-full line-clamp-1">
                <span className="mt-0.5">
                  <MapPin size={14} />
                </span>
                <p className='text-sm'>{form.location || 'None'}</p>
              </div>
            </div>
          ))}
{/* {allSubmitted && !isSubmittted && otpEnable && ( */}
           
            {/* )} */}
        </div>

      )}
    </div>

    {/* Modals */}
    {open && (
      <SendOTP
        scheduleViewId={scheduleViewId}
        onClose={() => setOpen(false)}
        fetchTasks={fetchTasks}
      />
    )}
    {openEnable && (
      <ModalContainer
        visiable={openEnable}
        title="Confirm"
        content={
          <div>
            <p>Are You Sure! You want to <span className="font-semibold">Verify</span> this Form?</p>
          </div>
        }
        handleClick={handleVerifyOTP}
        closeModal={() => setEnableOpen(false)}
        isLoading={loading}
      />
    )}

  </div>
</InSchedulelayout>

  );
}

export default NewForm;